import { Icon } from "../ui/Icon";

export function SP(params: { count: number }) {
  return (
    params.count > 0 && (
      <span
        style={{
          display: "flex",
          alignItems: "start",
          columnGap: 5,
          fontSize: 14,
          lineHeight: "1",
        }}
      >
        <Icon icon="etc_sp_point_i00" size={16} />
        <span style={{ color: "#fff" }}>{params.count}</span>
      </span>
    )
  );
}
